import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "Cities" }
const _hoisted_2 = { class: "flex itemscenter justify-between mt-6" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-gray-400 mt-3"
}
const _hoisted_5 = { class: "flex items-center justify-end mt-3" }
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-start"
}
const _hoisted_8 = {
  key: 1,
  class: "flex items-center justify-start"
}
const _hoisted_9 = {
  key: 2,
  class: "flex items-center justify-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_cities_table_actions = _resolveComponent("cities-table-actions")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.delete_modal_state.is_opened)
      ? (_openBlock(), _createBlock(_component_the_modal, {
          key: 0,
          title: "Удаление города",
          class: "medium",
          "is-confirm": "",
          loading: _ctx.delete_modal_state.is_loading,
          "confirm-message": _ctx.deleteCityText,
          onCancel: _ctx.onDeleteCityCancel,
          onConfirm: _ctx.onDeleteCitySubmit
        }, null, 8, ["loading", "confirm-message", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Города" }),
      _createVNode(_component_router_link, { to: "/cities/create" }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "primary small" }, {
            default: _withCtx(() => [
              _createTextVNode(" Добавить город ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      class: "flex flex-col px-6 py-4 border bg-white mt-6",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchCity && _ctx.searchCity(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_input, {
          placeholder: "Поиск по названию города",
          value: _ctx.filters_state.search_query,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.search_query) = $event)),
          class: "w-full"
        }, null, 8, ["value"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          value: _ctx.filters_state.regionId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.regionId) = $event)),
          placeholder: "Регион",
          loading: _ctx.data_state.regions.is_loading,
          options: _ctx.data_state.regions.list,
          "search-by": "name",
          label: "name",
          class: "mt-2"
        }, null, 8, ["value", "loading", "options"]),
        _createVNode(_component_the_select, {
          value: _ctx.filters_state.statusId,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.statusId) = $event)),
          placeholder: "Статус",
          "can-deselect": "",
          options: _ctx.STATUS_OPTIONS,
          class: "w-full mt-2",
          searchable: false
        }, null, 8, ["value", "options"]),
        _createVNode(_component_the_input, {
          placeholder: "Почтовый индекс",
          value: _ctx.filters_state.postCode,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.postCode) = $event)),
          class: "w-full"
        }, null, 8, ["value"])
      ]),
      (_ctx.cities_copy.is_search)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Найдено: " + _toDisplayString(_ctx.state.list.length), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_the_button, {
          class: "second text small mr-3",
          loading: _ctx.cities_copy.is_search,
          onClick: _ctx.resetFilter
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary text small w-fit",
          loading: _ctx.cities_copy.is_search,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка городов произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadCities(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.CitiesColumns,
                rows: _ctx.state.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadCities,
                onChangeLimit: _ctx.onLimitChange
              }, {
                td: _withCtx(({ row, column }) => [
                  (column.key === 'center')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_cheap, {
                          class: _normalizeClass(["small", { green: row.latitude && row.longitude }])
                        }, {
                          default: _withCtx(() => [
                            (row.latitude && row.longitude)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" Установлен ")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("Не установлен")
                                ], 64))
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      ]))
                    : (column.key === 'status')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_cheap, {
                            class: _normalizeClass(["small", { green: row.statusId === 1 }])
                          }, {
                            default: _withCtx(() => [
                              (row.statusId === 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" Активный ")
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("Не активный")
                                  ], 64))
                            ]),
                            _: 2
                          }, 1032, ["class"])
                        ]))
                      : (column.key === 'borders')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_cheap, {
                              class: _normalizeClass(["small", { green: Boolean(row.coordinates) }])
                            }, {
                              default: _withCtx(() => [
                                (Boolean(row.coordinates))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("Установлены")
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("Не установлены")
                                    ], 64))
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ]))
                        : (column.key === 'createdAt')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(row[column.key])), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              _createTextVNode(_toDisplayString(row[column.key]), 1)
                            ], 64))
                ]),
                actions: _withCtx(({ row }) => [
                  _createVNode(_component_cities_table_actions, {
                    city: row,
                    onReload: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadCities(_ctx.state.pagination.current_page))),
                    onDelete: _ctx.onDeleteCity
                  }, null, 8, ["city", "onDelete"])
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}